import { render, staticRenderFns } from "./tripList.vue?vue&type=template&id=1e510681&scoped=true&"
import script from "./tripList.vue?vue&type=script&lang=js&"
export * from "./tripList.vue?vue&type=script&lang=js&"
import style0 from "./tripList.vue?vue&type=style&index=0&id=1e510681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e510681",
  null
  
)

export default component.exports